import EditIcon from "@/assets/icons/EditIcon";
import DescriptionForm from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/Shared/DescriptionForm";
import { Paragraph } from "@/components/ui/Typography";
import { useMicroSiteContext } from "@/contexts/MicroSiteContext";
import { useState } from "react";
const Overview = () => {
    const { templatePayload, updateTemplatePayload } = useMicroSiteContext();
    const isEdit = new URLSearchParams(window.location.search).get('action') === 'edit';
  const [isEditing, setIsEditing] = useState(false);

       const handleSave = (formData: { description: string; }) => {
        setIsEditing(false);
        const updatedPayload = {
          ...templatePayload,
          footerSection: {
            ...templatePayload.footerSection,
            footerDescription: formData.description
          },
        };      
        updateTemplatePayload(updatedPayload);
      };

  const PreviewComponent = () => {
    return (
      <div className="flex relative justify-end lg:w-1/3 w-full" >   
          <div className="flex gap-3" >
          <Paragraph className="text-right ">{templatePayload.footerSection.footerDescription}</Paragraph>
{isEdit && <EditIcon width={40}  className="cursor-pointer" onClick={() => setIsEditing(true)} />}
          </div>
      </div>
    )
  };


  return (
    <>
      {isEditing ? <DescriptionForm handleSave={handleSave} handleCancel={() => setIsEditing(false)} data={{ description: templatePayload.footerSection.footerDescription }} /> : <PreviewComponent />}
    </>
  )
}

export default Overview